function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Website",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Products-Copy",
  transform: "translate(-232.000000, -300.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(232.000000, 300.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "docs",
  transform: "translate(0.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.69663,10.0274454 L50.0082989,10.0274454 L50.0082989,6.32294657 C50.0082989,5.59985 49.4248696,5.01372271 48.7047889,5.01372271 L45.0165977,5.01372271 L45.0165977,1.30922386 C45.0165977,0.58612729 44.4331685,0 43.7130878,0 L1.30350997,0 C0.58342922,0 0,0.586267915 0,1.30922386 L0,60.663612 C0,61.3867085 0.58342922,61.9728358 1.30350997,61.9728358 L4.99170112,61.9728358 L4.99170112,65.6771941 C4.99170112,66.4002906 5.57513034,66.9864179 6.29521108,66.9864179 L9.98340223,66.9864179 L9.98340223,70.6907761 C9.98340223,71.4138727 10.5668315,72 11.2869122,72 L53.69649,72 C54.4165708,72 55,71.4137321 55,70.6907761 L55,11.3366693 C55,10.6135727 54.4167108,10.0274454 53.69663,10.0274454 Z M2.60701994,59.3543881 L2.60701994,2.61858835 L42.4094378,2.61858835 L42.4094378,59.3543881 L2.60701994,59.3543881 Z M7.59900108,64.3681108 L7.59900108,61.9728358 L43.7129478,61.9728358 C44.4330285,61.9728358 45.0164577,61.3865679 45.0164577,60.663612 L45.0164577,7.63231106 L47.4012789,7.63231106 L47.4012789,64.3681108 L7.59900108,64.3681108 L7.59900108,64.3681108 Z M52.39298,69.3816929 L12.5905622,69.3816929 L12.5905622,66.9865585 L48.7047889,66.9865585 C49.4248696,66.9865585 50.0082989,66.4002906 50.0082989,65.6773347 L50.0082989,12.6460338 L52.39298,12.6460338 L52.39298,69.3816929 Z",
  id: "Shape",
  fill: "#73868C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.6867734,14 L15.3133677,14 C14.5878414,14 14,14.4477981 14,15 C14,15.5522019 14.5878414,16 15.3133677,16 L29.6866323,16 C30.4121586,16 31,15.5522019 31,15 C31,14.4477981 30.4122997,14 29.6867734,14 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6818182,21 L9.31818182,21 C8.58999609,21 8,21.4477981 8,22 C8,22.5522019 8.58999609,23 9.31818182,23 L35.6818182,23 C36.4100039,23 37,22.5522019 37,22 C37,21.4477981 36.4098623,21 35.6818182,21 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6818182,27 L9.31818182,27 C8.58999609,27 8,27.4477981 8,28 C8,28.5522019 8.58999609,29 9.31818182,29 L35.6818182,29 C36.4100039,29 37,28.5522019 37,28 C37,27.4477981 36.4098623,27 35.6818182,27 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6818182,33 L9.31818182,33 C8.58999609,33 8,33.4477981 8,34 C8,34.5522019 8.58999609,35 9.31818182,35 L35.6818182,35 C36.4100039,35 37,34.5522019 37,34 C37,33.4477981 36.4098623,33 35.6818182,33 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6818182,40 L9.31818182,40 C8.58999609,40 8,40.4477981 8,41 C8,41.5522019 8.58999609,42 9.31818182,42 L35.6818182,42 C36.4100039,42 37,41.5522019 37,41 C37,40.4477981 36.4098623,40 35.6818182,40 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.6818182,46 L9.31818182,46 C8.58999609,46 8,46.4477981 8,47 C8,47.5522019 8.58999609,48 9.31818182,48 L35.6818182,48 C36.4100039,48 37,47.5522019 37,47 C37,46.4477981 36.4098623,46 35.6818182,46 Z",
  id: "Path",
  fill: "#7CA1A6"
})), /*#__PURE__*/React.createElement("g", {
  id: "docs-copy",
  transform: "translate(83.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  stroke: "#7CA1A6",
  fill: "#343E40",
  points: "0.550434798 99.0458127 0.550434798 0.546160337 70.023746 0.546160337 70.023746 99.0458127"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.7597899,20 L23.2404508,20 C22.0027882,20 21,20.8955961 21,22 C21,23.1044039 22.0027882,24 23.2404508,24 L47.7595492,24 C48.9972118,24 50,23.1044039 50,22 C50,20.8955961 48.9974524,20 47.7597899,20 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7272727,32 L12.2727273,32 C11.0172346,32 10,32.8955961 10,34 C10,35.1044039 11.0172346,36 12.2727273,36 L57.7272727,36 C58.9827654,36 60,35.1044039 60,34 C60,32.8955961 58.9825212,32 57.7272727,32 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7272727,42 L12.2727273,42 C11.0172346,42 10,42.8955961 10,44 C10,45.1044039 11.0172346,46 12.2727273,46 L57.7272727,46 C58.9827654,46 60,45.1044039 60,44 C60,42.8955961 58.9825212,42 57.7272727,42 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7272727,54 L12.2727273,54 C11.0172346,54 10,54.8955961 10,56 C10,57.1044039 11.0172346,58 12.2727273,58 L57.7272727,58 C58.9827654,58 60,57.1044039 60,56 C60,54.8955961 58.9825212,54 57.7272727,54 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7272727,64 L12.2727273,64 C11.0172346,64 10,64.8955961 10,66 C10,67.1044039 11.0172346,68 12.2727273,68 L57.7272727,68 C58.9827654,68 60,67.1044039 60,66 C60,64.8955961 58.9825212,64 57.7272727,64 Z",
  id: "Path",
  fill: "#7CA1A6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.7272727,76 L12.2727273,76 C11.0172346,76 10,76.8955961 10,78 C10,79.1044039 11.0172346,80 12.2727273,80 L57.7272727,80 C58.9827654,80 60,79.1044039 60,78 C60,76.8955961 58.9825212,76 57.7272727,76 Z",
  id: "Path",
  fill: "#7CA1A6"
})))));

var SvgScooterAgnostic = function SvgScooterAgnostic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "154px",
    height: "100px",
    viewBox: "0 0 154 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScooterAgnostic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scooter-agnostic.33061d2a.svg";
export { ForwardRef as ReactComponent };